/**
 * Video Grid Section
 * Handles video playback and interactions
 */

(function() {
  'use strict';

  // Video Grid Slider Component (for mobile)
  if (!customElements.get('video-grid-slider')) {
    class VideoGridSlider extends HTMLElement {
      constructor() {
        super();
        this.initSlider();
      }

      initSlider() {
        // Only initialize Swiper on mobile (749px and below)
        if (window.innerWidth <= 749) {
          if (typeof Swiper !== 'undefined') {
            new Swiper(this, {
              spaceBetween: 26,
              slidesPerView: 1.3,
              centeredSlides: false,
              loop: false,
              navigation: {
                nextEl: this.querySelector('.swiper-button-next'),
                prevEl: this.querySelector('.swiper-button-prev'),
              },
            });
          }
        }
      }
    }
    customElements.define('video-grid-slider', VideoGridSlider);
  }

  class VideoGrid {
    constructor(container) {
      this.container = container;
      this.videos = container.querySelectorAll('.video-grid__video');
      this.init();
    }

    init() {
      // Ensure videos are playing (some browsers may pause autoplay)
      this.ensureVideosPlaying();
      
      // Handle visibility changes (pause when not visible, play when visible)
      this.handleVisibilityChange();
    }

    ensureVideosPlaying() {
      this.videos.forEach((video) => {
        // Ensure video is muted for autoplay
        if (!video.muted) {
          video.muted = true;
        }

        // Try to play the video
        const playPromise = video.play();
        
        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              // Video is playing
            })
            .catch((error) => {
              // Autoplay was prevented, log for debugging
              console.log('Video autoplay prevented:', error);
            });
        }
      });
    }

    handleVisibilityChange() {
      // Pause videos when page is hidden, play when visible
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.videos.forEach((video) => {
            video.pause();
          });
        } else {
          this.videos.forEach((video) => {
            const playPromise = video.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => {
                // Ignore play errors
              });
            }
          });
        }
      });
    }

    onUnload() {
      // Cleanup if needed
      this.videos.forEach((video) => {
        video.pause();
        video.src = '';
        video.load();
      });
    }
  }

  // Register with theme sections if available
  if (typeof theme !== 'undefined' && theme.Sections) {
    theme.Sections.prototype.register = theme.Sections.prototype.register || function(type, constructor) {
      this.constructors[type] = constructor;
    };

    theme.Sections.prototype.register('video-grid', VideoGrid);
  }

  // Initialize on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function() {
    const videoGridSections = document.querySelectorAll('[data-section-type="video-grid"]');
    videoGridSections.forEach((section) => {
      new VideoGrid(section);
    });
  });

  // Handle Shopify section loading
  document.addEventListener('shopify:section:load', function(event) {
    const section = document.querySelector('[data-section-id="' + event.detail.sectionId + '"]');
    if (section && section.getAttribute('data-section-type') === 'video-grid') {
      new VideoGrid(section);
    }
  });
})();

